import { render } from "./page12.vue?vue&type=template&id=191f5062&scoped=true"
import script from "./page12.vue?vue&type=script&lang=js"
export * from "./page12.vue?vue&type=script&lang=js"

import "./page12.vue?vue&type=style&index=0&id=191f5062&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191f5062"]])

export default __exports__